import React from 'react'
import ChecklistRow from './ChecklistRow'

interface IOperatingAuthorityProps {
  operatingAuthority: {
    id: string
    fullName: string
  }
}

export const OperatingAuthority: React.FunctionComponent<IOperatingAuthorityProps> = React.memo(
  ({ operatingAuthority }) => {
    const { fullName, id } = operatingAuthority || {}
    return (
      <ChecklistRow
        sectionName='Operating Authority (both Federal and State if applicable)'
        id={id}
        fullName={fullName}
      />
    )
  }
)
